import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const accoladeBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE,
  BackgroundColor.TRANSPARENT,
  BackgroundColor.WHITE_FACET,
  BackgroundColor.MIDNIGHT_BLUE_FACET,
  BackgroundColor.PURPLE_FACET,
  BackgroundColor.DARK_MINT_FACET,
  BackgroundColor.MINT_FACET,
  BackgroundColor.BERRY_FACET,
  BackgroundColor.ORANGE_FACET,
  BackgroundColor.LIGHT_BLUE_FACET
] as const

export type AccoladeBackgroundColor = (typeof accoladeBackgroundColors)[number]
